import React, {Suspense, useEffect} from 'react'
import { Canvas } from '@react-three/fiber'
import { SoftShadows, Environment } from '@react-three/drei'
import Helicopter from './Helicopter.jsx'
import Heliport from './Heliport.jsx'
import Controls from '../../components/Controls.jsx'


function SceneLoadedBridge({ onLoaded }) {
  useEffect(() => {
    onLoaded?.(true);
  }, [onLoaded]);
  return null;
}


export default function ExteriorSceneThreeJS({ onLoaded, playing, heliRef, onReady, flightState, hidden, advanceFlightState }) {
    useEffect(() => {
      console.log('[LOG] ExteriorSceneThreeJS MOUNT');
      return () => {
        console.log('[LOG] ExteriorSceneThreeJS UNMOUNT');
      };
    }, []);
  const lightPosition = [-2, 4, -1.5];

  return (
    <Canvas
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 5, 
        opacity: hidden ? 0 : 1,
        pointerEvents: hidden ? "none" : "auto",
      }} 
      shadows
      dpr={Math.min(window.devicePixelRatio, 2)} 
      camera={{ near: 0.1, far: 5000, fov: 50 }}>

      <Environment
        files="/images/experiences/ext/citrus_orchard_road_puresky_1k.exr"
        environmentIntensity={0.8}
        resolution={512}
      />

      <SoftShadows size={ 25 } samples={ 10 } focus={ 0 } />

      <Controls enableZoom={true} lockY={true} />

      <directionalLight 
        position={ lightPosition } 
        intensity={ 4.5 }
        castShadow 
        shadow-normalBias={0.04}
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048} 
      />

      <ambientLight intensity={ 0.4 } />

      <Suspense>
        <SceneLoadedBridge onLoaded={onLoaded} />
        <group position={[0, -0.25, 0]}>
          <Helicopter 
            ref={heliRef}
            playing={playing}
            onReady={onReady}
            flightState={flightState}
            // scale={0.08} 
            rotation-y={0.3}
            castShadow 
            lightPosition={lightPosition} 
            advanceFlightState={advanceFlightState}
          />
          <Heliport
            size={[10, 6]}           // ancho/largo
            shadowOpacity={0.4}      // intensidad sombra
            position={[0, -0.46, 0]} // donde esté tu “piso”
          />
        </group>
      </Suspense>

    </Canvas>
  )
}
